export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20curated%20fashion%20products%20including%20sneakers%20hoodies%20caps%20bags%20watches%20and%20accessories%20arranged%20in%20organized%20grid%20pattern%20on%20warm%20cream%20textured%20surface%2C%20soft%20diffused%20natural%20lighting%20from%20above%2C%20clean%20minimalist%20editorial%20style%2C%20rich%20warm%20earth%20tones%2C%20high%20detail%20product%20photography%2C%20harmonious%20composition&width=1600&height=900&seq=hero-bg-002&orientation=landscape"
          alt="OOPBUY Spreadsheet Fashion Products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-16 text-center">
        <p className="text-xs md:text-sm font-medium text-background-200/80 uppercase tracking-[0.2em] mb-4">
          Updated Daily &middot; 2026
        </p>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 max-w-4xl mx-auto">
          Die beste OOPBUY
          <br />
          <span className="text-accent-400">Spreadsheet</span>
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          Durchstöbere die größte OOPBUY Spreadsheet mit über 3.000 handverlesenen Produkten
          von verifizierten Verkäufern. Täglich aktualisiert – dein ultimativer Guide für
          Smart Shopping.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold text-foreground-950 bg-background-50 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap inline-flex items-center gap-2"
          >
            Produkte ansehen
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-600 rounded-md hover:bg-primary-700 transition-colors whitespace-nowrap inline-flex items-center gap-2"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line"></i>
            </span>
            buy it now
          </a>
        </div>

        {/* Stats */}
        <div className="flex items-center justify-center gap-8 md:gap-16">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">3000+</p>
            <p className="text-xs text-background-300 uppercase tracking-wider mt-1">Produkte</p>
          </div>
          <div className="w-px h-10 bg-background-400/50"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">Daily</p>
            <p className="text-xs text-background-300 uppercase tracking-wider mt-1">Updates</p>
          </div>
          <div className="w-px h-10 bg-background-400/50"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">200k+</p>
            <p className="text-xs text-background-300 uppercase tracking-wider mt-1">Käufer</p>
          </div>
        </div>
      </div>
    </section>
  );
}